/* Popup Dialog Manager - extracted from commands.ts */

import { logger } from "@/helpers/tslog";
import {
  detectTitleAndSubtitleAboveSelection,
  handleMessage,
  placeholderSelection,
} from "@/utils/placeholderSelection";
import { resetEditLLM, resetLLM } from "@/utils/alphaAgent/resetLLM";
import { deleteParamsValid } from "@/utils/localstorage-params";
import { enableButton } from "@/commands/commands";
import { clearPositioningLocalStorage } from "./clearLocalStorage";

// commands.ts
let popupDialog: Office.Dialog;
export function openPopup(event?: Office.AddinCommands.Event) {
  logger.info(process.env.REACT_APP_PUBLIC_URL);
  const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
  const popupUrl = `${frontendUrl}/popup.html`;

  Office.context.ui.displayDialogAsync(popupUrl, { height: 85, width: 55, displayInIframe: true }, (result) => {
    logger.info(result);
    if (result.status === Office.AsyncResultStatus.Failed) {
      logger.error("Failed to open dialog:", result.error.message);
    } else {
      popupDialog = result.value;
      // Optional: Listen for messages from the popup
      // 🚀 Try to hide the task pane (works in Excel & Word)

      popupDialog.addEventHandler(Office.EventType.DialogMessageReceived, async (args: any) => {
        logger.info("Message received from popup:", args.message);
        await handleMessage(args, popupDialog, event);
      });
      var dialog = result.value;
      dialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog closed. Reason:");
        deleteParamsValid();
      });
    }
    if (event) {
      event.completed();
    }
  });
}

export function closePopup() {
  if (popupDialog) {
    popupDialog.close();
    popupDialog = null;
    logger.info("Popup closed.");
  } else {
    logger.warn("No popup is open.");
  }
}

export function formatTemplatePopup(event?: Office.AddinCommands.Event) {
  logger.info(process.env.REACT_APP_PUBLIC_URL);
  const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
  const popupUrl = `${frontendUrl}/formatTemplatePopup.html`;

  Office.context.ui.displayDialogAsync(popupUrl, { height: 75, width: 65, displayInIframe: true }, (result) => {
    logger.info(result);
    if (result.status === Office.AsyncResultStatus.Failed) {
      logger.error("Failed to open dialog:", result.error.message);
    } else {
      popupDialog = result.value;
      popupDialog.addEventHandler(Office.EventType.DialogMessageReceived, async (args: any) => {
        logger.info("Message received from popup:", args.message);
        await handleMessage(args, popupDialog, event);
      });
      var dialog = result.value;
      dialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog closed. Reason:");
        deleteParamsValid();
      });
    }
    if (event) {
      event.completed();
    }
  });
}

// let placeholderPopupDialog: Office.Dialog;
export async function placeholderPopup(event?: Office.AddinCommands.Event) {
  const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
  const popupUrl = `${frontendUrl}/placeholderPopup.html`;
  await resetLLM();
  clearPositioningLocalStorage();
  localStorage.removeItem("alphaEdit");
  Office.context.ui.displayDialogAsync(popupUrl, { height: 85, width: 55, displayInIframe: true }, (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
      logger.error("Failed to open dialog:", result.error.message);
    } else {
      let placeholderPopupDialog = result.value;
      placeholderPopupDialog.addEventHandler(Office.EventType.DialogMessageReceived, async (args: any) => {
        await handleMessage(args, placeholderPopupDialog, event);
      });
      let dialog2 = result.value;
      dialog2.addEventHandler(Office.EventType.DialogMessageReceived, async () => {
        await detectTitleAndSubtitleAboveSelection();
      });
      var dialog = result.value;
      dialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog closed. Reason:");
        await resetLLM();
        clearPositioningLocalStorage();
        deleteParamsValid();
      });
    }
    if (event) {
      event.completed();
    }
  });
}

export function feedbackSupportPopup(event?: Office.AddinCommands.Event) {
  logger.info(process.env.REACT_APP_PUBLIC_URL);
  const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
  const popupUrl = `${frontendUrl}/feedbackSupportPopup.html`;
  Office.context.ui.displayDialogAsync(popupUrl, { height: 40, width: 40, displayInIframe: true }, (result) => {
    logger.info(result);
    if (result.status === Office.AsyncResultStatus.Failed) {
      logger.error("Failed to open dialog:", result.error.message);
    } else {
      popupDialog = result.value;
      popupDialog.addEventHandler(Office.EventType.DialogMessageReceived, async (args: any) => {
        logger.info("Message received from popup:", args.message);
      });
      var dialog = result.value;
      dialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog closed. Reason:");
        deleteParamsValid();
      });
    }
    if (event) {
      event.completed();
    }
  });
}

export function updatePlaceholderPopupOpen(event?: Office.AddinCommands.Event) {
  const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
  const popupUrl = `${frontendUrl}/updatePlaceholder.html`;
  Office.context.ui.displayDialogAsync(popupUrl, { 
    height: 26,
    width: 30, 
    displayInIframe: true
  }, (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
      logger.error("Failed to open dialog:", result.error.message);
    } else {
      const dialog = result.value;
      Office.context.document.addHandlerAsync(Office.EventType.DocumentSelectionChanged, async () => {
        logger.info("Document selection changed, calling selectionChatImage.");
        await placeholderSelection();
      });
      dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (args: any) => {
        await handleMessage(args, dialog, event);
      });
      dialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog closed. Reason:");
        deleteParamsValid();
      });
    }
    if (event) {
      event.completed();
    }
  });
}

let chatPopupDialog: Office.Dialog;
export function alphaPopupOpen(event?: Office.AddinCommands.Event) {
  const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
  const popupUrl = `${frontendUrl}/alpha-popup.html`;
  Office.context.ui.displayDialogAsync(popupUrl, { height: 85, width: 50, displayInIframe: true }, async (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
    } else {
      chatPopupDialog = result.value;
      chatPopupDialog.addEventHandler(Office.EventType.DialogMessageReceived, async (args: any) =>
        handleMessage(args, chatPopupDialog, event)
      );
      var dialog = result.value;
      dialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog closed. Reason:");
        await resetLLM();
        localStorage.removeItem("messages");
        localStorage.removeItem("alphaCreateData");
        deleteParamsValid();
      });
    }
    if (event) {
      event.completed();
    }
  });
}

let chatEditPopupDialog: Office.Dialog;
export async function alphaEditPopupOpen(event?: Office.AddinCommands.Event) {
  const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
  const popupUrl = `${frontendUrl}/alphaEditPopup.html`;
  clearPositioningLocalStorage();
  await resetEditLLM();
  Office.context.ui.displayDialogAsync(popupUrl, { height: 85, width: 60, displayInIframe: true }, async (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
    } else {
      chatEditPopupDialog = result.value;
      chatEditPopupDialog.addEventHandler(
        Office.EventType.DialogMessageReceived,
        (args: Office.DialogParentMessageReceivedEventArgs) => handleMessage(args, chatEditPopupDialog, event)
      );
      chatEditPopupDialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog event received, closing popup.");
        localStorage.removeItem("documentId");
        await enableButton(false);
      });
      var dialog = result.value;
      dialog.addEventHandler(Office.EventType.DialogEventReceived, async function () {
        logger.info("Dialog closed. Reason:");
        await resetEditLLM();
        clearPositioningLocalStorage();
        deleteParamsValid();
      });
    }
    if (event) {
      event.completed();
    }
  });
}


export function openContentManager(event?: Office.AddinCommands.Event) {
  try {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
    const url = `${frontendUrl}/contentManager.html`;
    Office.context.ui.displayDialogAsync(url, { height: 50, width: 70, displayInIframe: true }, async (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          await handleMessage(arg, dialog, event);
        });
      }
    });
  } catch (e) {
    // no-op
  } finally {
    event?.completed();
  }
}

export function openContentFraming(event?: Office.AddinCommands.Event) {
  try {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
    const url = `${frontendUrl}/contentFraming.html`;
    Office.context.ui.displayDialogAsync(url, { height: 85, width: 98, displayInIframe: true }, async (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          await handleMessage(arg, dialog, event);
        });
      }
    });
  } catch (e) {
    // no-op
  } finally {
    event?.completed();
  }
}

export function openConfirmPlaceholder(event?: Office.AddinCommands.Event) {
  try {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
    const url = `${frontendUrl}/confirmPlaceholder.html`;
    Office.context.ui.displayDialogAsync(url, { height: 15, width: 15, displayInIframe: true }, async (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          await handleMessage(arg, dialog, event);
        });
      }
    });
  } catch (e) {
    // no-op
  } finally {
    event?.completed();
  }
}

export function slidesPopup(event?: Office.AddinCommands.Event) {
  try {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
    const url = `${frontendUrl}/contentSlide.html`;
    Office.context.ui.displayDialogAsync(url, { height: 75, width: 60, displayInIframe: true }, async (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          await handleMessage(arg, dialog, event);
        });
      }
    });
  } catch (e) {
    // no-op
  } finally {
    event?.completed();
  }
}

export function slideEditPopup(event?: Office.AddinCommands.Event) {
  try {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
    const url = `${frontendUrl}/slideEdit.html`;
    Office.context.ui.displayDialogAsync(url, { height: 75, width: 60, displayInIframe: true }, async (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          await handleMessage(arg, dialog, event);
        });
      }
    });
  } catch (e) {
    // no-op
  } finally {
    event?.completed();
  }
}

export function presentationPopup(event?: Office.AddinCommands.Event) {
  try {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
    const url = `${frontendUrl}/presentation.html`;
    Office.context.ui.displayDialogAsync(url, { height: 87, width: 65, displayInIframe: true }, async (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const dialog = result.value;
        dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
          await handleMessage(arg, dialog, event);
        });
      }
    });
  } catch (e) {
    // no-op
  } finally {
    event?.completed();
  }
}

// Lightweight loading popup shown during refresh
let loadingPopupDialog: Office.Dialog | null = null;
export function openLoadingPopup() {
  try {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL as string;
    const popupUrl = `${frontendUrl}/loadingPopup.html`;
    Office.context.ui.displayDialogAsync(popupUrl, { height: 15, width: 10, displayInIframe: true }, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        loadingPopupDialog = result.value;
      }
    });
  } catch {}
}

export function closeLoadingPopup() {
  try {
    if (loadingPopupDialog) {
      loadingPopupDialog.close();
      loadingPopupDialog = null;
    }
  } catch {}
}

// Opens the specified Excel file URL (hardcoded for initial implementation)
export function openExcelWithHardcodedUrl() {
  try {
    const url = localStorage.getItem("excelFileUrl");
    if (!url) {
      logger.error("No Excel file URL found in localStorage");
      return;
    }
    // const url = "https://alphascriptsolutions-my.sharepoint.com/personal/abdul_alphascript_io/_layouts/15/Doc.aspx?sourcedoc=%7BDB8D7D9F-6699-4EDC-831E-64E7EA322B8F%7D&file=AlphaScript_Share_Price_Performance_Line_Chart_01K77NQB4S2QPE4Y3BKRGNXJFX_2025-10-10_11_24%20PM%20GMT%2B5.xlsx&action=default&mobileredirect=true";
    const deepLinks = [
      `ms-excel:ofv|u|${encodeURIComponent(url)}`, // view
      `ms-excel:ofe|u|${encodeURIComponent(url)}`, // edit
    ];
    try { logger.info("[ExcelOpen] Prepared deep links", { deepLinks }); } catch {}

    // Try each deep link scheme
    for (const link of deepLinks) {
      try {
        try { logger.info("[ExcelOpen] Trying window.location.href", { link }); } catch {}
        window.location.href = link;
        break;
      } catch {}
      try {
        try { logger.info("[ExcelOpen] Trying window.open _self", { link }); } catch {}
        window.open(link, "_self");
        break;
      } catch {}
    }

    // Fallback: open in browser if protocol is blocked
    setTimeout(() => {
      try {
        try { logger.warn("[ExcelOpen] Deep link blocked; opening web URL as fallback"); } catch {}
        window.open(url, "_blank");
      } catch {}
    }, 3000);
  } catch (e) {
    try { logger.error("Failed to open Excel URL", e as any); } catch {}
  }
}
